import type {FormikProps} from 'formik'
import {withFormik} from 'formik'
import React from 'react'
import {sendEmail} from 'src/api/sendgrid'
import {makeEmploymentMessage} from 'src/utils/email'
import styled from 'styled-components'
import {palette} from 'styled-tools'
import {Button} from '../../buttons'
import type {EmploymentFormValues} from './EmploymentFormFields'
import EmploymentFormFields, {
  validateEmploymentFormFields,
} from './EmploymentFormFields'

type MyFormProps = Record<string, never>

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Status = styled.div`
  margin-top: 16px;
  text-align: center;
`
const Error = styled.div`
  margin-top: 16px;
  text-align: center;
  color: ${palette('red')};
`

const Form = ({
  handleSubmit,
  isSubmitting,
  status,
}: FormikProps<EmploymentFormValues>): JSX.Element => (
  <form onSubmit={handleSubmit}>
    <EmploymentFormFields />
    <ButtonWrapper>
      <Button type="submit" disabled={isSubmitting}>
        Senda umsókn
      </Button>
      {!!status?.success && <Status>{status.success}</Status>}
      {!!status?.error && <Error>{status.error}</Error>}
    </ButtonWrapper>
  </form>
)

const EmploymentFormik = withFormik<MyFormProps, EmploymentFormValues>({
  mapPropsToValues: () => ({
    name: '',
    ssn: '',
    address: '',
    postalCode: undefined,
    city: '',
    phone: '',
    email: '',
    type: '',
    job: '',
    family: '',
    hobbies: '',
    education: '',
    references: '',
    hours: '',
    start: '',
    smoker: '',
    time: '',
    file: undefined,
  }),

  validate: (values) => validateEmploymentFormFields(values),

  handleSubmit: (values, {setSubmitting, setStatus}) => {
    const message = makeEmploymentMessage(values)
    sendEmail(values.name, 'Umsókn um starf', message, values.file).then(
      (res) => {
        if (res.status !== 200) {
          setSubmitting(false)
          setStatus({
            error: 'Eitthvað fór úrskeiðis. Vinsamlegast reyndu aftur.',
          })
        } else {
          setStatus({success: 'Umsókn móttekin'})
        }
      },
    )
  },
  displayName: 'EmploymentForm',
})(Form)

export default function EmploymentForm(): JSX.Element {
  return <EmploymentFormik />
}
